import { useRoot } from './RootProvider';

export function useAssets() {
  return useRoot().assets;
}
